import { Icon, Icons } from 'components/Icon';
import { InfoModal } from 'components/Modal';
import React from 'react';
import { Activity } from 'service/dto/prospect.dto';

type IProps = {
  onClose: () => void;
  note: Activity;
};

export default function NoteViewModal({ onClose, note }: IProps) {
  return (
    <InfoModal width="w-[60%]" className="h-fit rounded-lg py-2">
      <div className=" text-[#626465]">
        <div className="border-b border-black/30">
          <div className="bottom-1 flex items-center justify-between p-5 px-10">
            <p className="text-3xl font-bold text-[#353535]">
              Note -{' '}
              <span className="text-base font-normal">{note.contactDate}</span>
            </p>
            <button type="button" onClick={onClose}>
              <Icon name={Icons.Close} />
            </button>
          </div>
        </div>
        <p className="p-12 text-xs">
          <p className="text-[12px] font-[500] text-[#434343]">
            {note.narration}
          </p>
        </p>
      </div>
    </InfoModal>
  );
}
